import { isNil } from "lodash";
import React, { ChangeEvent, Component } from "react";
import IGetVendorsDTO from "../../../models/DTO/IGetVendorsDTO";
import IOnGetVendorsDTO from "../../../models/DTO/IOnGetVendorsDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import UIService from "../../../services/UIService";
import ChevronToggle from "../../shared/ChevronToggle/ChevronToggle";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import Typeahead from "../../shared/Typeahead/Typeahead";
import { Socket } from "socket.io-client";

type Props = {
    history: any;
    socket: Socket;
    searchFn: (queryString?: string) => void;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
};

type State = {
    foundVendors: IVendorModel[];
    clearVendorTypeahead: boolean;
    selectedVendor: IVendorModel | null;
    isVisible: boolean;
    pick_list_name: string;
    order_name: string;
    filter_completed: boolean;
};

class PickListFilter extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            foundVendors: [],
            clearVendorTypeahead: false,
            selectedVendor: null,
            isVisible: true,
            pick_list_name: "",
            order_name: "",
            filter_completed: true,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);
    }

    toggleVisible = () => {
        this.setState({
            isVisible: !this.state.isVisible,
        });
    };

    doTypeahead = (name: string) => {
        const payload: IGetVendorsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            nameGuidOnly: true,
            queryString: `name=${name}`,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        const foundVendors = data.supplierVendorTokens.map((token) => {
            return token.Vendor!;
        });

        this.setState({
            foundVendors,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    getQuery = () => {
        const query: string[] = [];

        if (!isNil(this.state.selectedVendor)) {
            query.push(`vendor_guid=${this.state.selectedVendor.guid}`);
            query.push(`vendor_name=${this.state.selectedVendor.name}`);
        }

        if (!isNil(this.state.order_name) && this.state.order_name.length) {
            query.push(`order_name=${this.state.order_name}`);
        }

        if (!isNil(this.state.pick_list_name) && this.state.pick_list_name.length) {
            query.push(`pick_list_name=${this.state.pick_list_name}`);
        }

        if (!isNil(this.state.filter_completed) && this.state.filter_completed) {
            query.push(`filter_completed=${this.state.filter_completed}`);
        }

        return query;
    };

    search = () => {
        const query = this.getQuery();

        let queryString = "";

        if (query.length) {
            queryString = "?";

            queryString += query.join("&");
        }

        this.props.history({
            pathname: "/pick_lists",
            search: queryString,
        });

        if (query.length) {
            queryString = "?";

            queryString += query.join("&");
        }

        this.props.searchFn(queryString);
    };

    reset = () => {
        this.setState(
            {
                order_name: "",
                pick_list_name: "",
                clearVendorTypeahead: true,
                filter_completed: true,
                selectedVendor: null,
            },
            () => {
                this.search();
            }
        );
    };

    clearVendorTypeahead = () => {
        this.setState({
            selectedVendor: null,
            clearVendorTypeahead: false,
        });
    };

    selectVendor = (selectedVendor: IVendorModel) => {
        this.setState({
            selectedVendor,
        });
    };

    render() {
        let cardClass = "dark-card text-white bg-secondary";

        if (UIService.isMainViewLight()) {
            cardClass = "";
        }

        return (
            <div className={"PickListFilter d-print-none"}>
                <div className={"row mb-2"}>
                    <div className={"col-12 col-md-4"}>
                        <OwLabel title={"vendor"} supplierModel={this.props.supplierModel} isSupplierVendorOverride={true} />
                        <Typeahead
                            isSelectableFn={() => {
                                return true;
                            }}
                            typeaheadApiFn={this.doTypeahead}
                            titleProp={"name"}
                            selectedItemFn={this.selectVendor}
                            typeaheadItems={this.state.foundVendors}
                            selectedItem={this.state.selectedVendor}
                            selectedItemTitleProp={"name"}
                            clearTypeahead={this.state.clearVendorTypeahead}
                            clearTypeaheadCallback={this.clearVendorTypeahead}
                        />
                    </div>

                    <div className={"col-12 col-md-4 mb-2"}>
                        <OwLabel title={"pick_list"} />
                        <OwInputWrapper name={"pick_list_name"} value={this.state.pick_list_name} fn={this.handleChange} />
                    </div>

                    <div className={"col-12 col-md-4 mb-2"}>
                        <OwLabel title={"order"} />
                        <OwInputWrapper name={"order_name"} value={this.state.order_name} fn={this.handleChange} />
                    </div>
                </div>

                <div className={"w-100 mb-2"}>
                    <OwCheckbox
                        label={"filter_completed"}
                        name={"filter_completed"}
                        fn={this.handleChange}
                        checked={this.state.filter_completed}
                        truthyVal={true}
                        falsyVal={false}
                    />
                </div>

                <div className={"w-100 mb-2"}>
                    <OwButton title={"search"} fn={this.search} />
                    <OwButton title={"reset"} fn={this.reset} className={" ms-2 btn-danger"} />
                </div>
            </div>
        );
    }
}

export default PickListFilter;
